import CharacterSet from '@/components/CharacterSet'
import { createDataAttribute } from 'next-sanity'

interface CharacterSetBlockProps {
	heading?: string
	fonts: {
		name: string
		file: any
		weight: string|number
		style: 'normal'|'italic'
	}[]
	documentId: string
	_key: string
}

export default function CharacterSetBlock({ heading, fonts, documentId, _key }: CharacterSetBlockProps) {
	return (
		<div
			className="section col-span-full my-section--sm"
			key={_key}
			data-sanity={createDataAttribute({
				id: documentId,
				type: 'project',
				path: `contentBlocks[_key=="${_key}"]`,
			}).toString()}
		>
			<CharacterSet
				heading={heading || "Character Set"}
				fonts={fonts}
			/>
		</div>
	)
}
